module.exports = __webpack_public_path__ + "img/visanet.0effe874.png";